import { initializeApp } from "firebase/app";
//import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Follow this pattern to import other Firebase services
// import { } from 'firebase/<service>';

// TODO: Replace the following with your app's Firebase project configuration

const firebaseConfig = {
  apiKey: "AIzaSyCb4msefmKYgc6pIeNDIZqv8qUe7vFFQAQ",
  authDomain: "neobuq1.firebaseapp.com",
  projectId: "neobuq1",
  storageBucket: "neobuq1.appspot.com",
  messagingSenderId: "536441474395",
  appId: "1:536441474395:web:12ce3fc4a9285cbeb2de7e",
  measurementId: "G-MBM8QD13ED"
};

console.log("inicializando App");
const app = initializeApp(firebaseConfig);
const auth = getAuth();
export const db = getFirestore(app);
export { auth };
db._settings.experimentalAutoDetectLongPolling = true;
//connectFirestoreEmulator(db, "localhost", 8090);
